<div class="limitExhaustPopup">
    <div class="limitExhaustPopupContainer">
        <div class="header-section">
            <div class="trinka-logo-n-cross">
                <img src="../../../assets/images/trinka-new-logo.svg" alt="trinka-ai-detector">
                <button mat-icon-button aria-label="close dialog" mat-dialog-close>
                    <mat-icon>close</mat-icon>
                </button>
            </div>
            <h5>1日の制限文字数を超えました</h5>
        </div>
        <div class="body-section">
            ご登録いただくと、文法チェッカー、校正ファイル、パラフレーザー、盗用チェッカーなど、英語の文書・英文コンテンツのためのTrinkaの各種機能をご利用いただけます。
        </div>
        <div class="footer-section">
            <button (click)="redirectToSignupPage()">無料で登録する</button>
        </div>
    </div>
</div>